import { policyList } from "@/enums/permissions";
import AccountService from "@/services/account.services";
import { messagesService } from "@/services/messages.service";
import { RootState } from "@/vuex/types";
import { ActionContext, ActionTree } from "vuex";
import { AccountState } from "./account.types";

type AccountManagementActionContext = ActionContext<AccountState, RootState>;

type AccountManagementActionTree = ActionTree<AccountState, RootState>;

export const actions: AccountManagementActionTree = {
  async loadAccountData(context: AccountManagementActionContext): Promise<any> {
    try {
      context.commit("setLoading", true);
      const data = await AccountService.getAccount();
      context.commit("setAccountData", data);
    } catch (e) {
      messagesService.renderErrorMessage(e);
    } finally {
      context.commit("setLoading", false);
    }
  },

  async loadAvailability(
    context: AccountManagementActionContext
  ): Promise<any> {
    const hasPermission = context.rootGetters["authModule/hasPermission"];
    if (
      hasPermission(policyList.viewUserSeats) ||
      hasPermission(policyList.viewLocationSeats)
    ) {
      try {
        context.commit("setLoadingAvailability", true);
        const user = context.rootGetters["authModule/user"];
        const response = await AccountService.getAvailability(
          user.settings.current_account_id
        );
        context.commit("setAvailability", response.data);
      } catch (e) {
        messagesService.renderErrorMessage(e);
      } finally {
        context.commit("setLoadingAvailability", false);
      }
    }
  }
};
